/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Complete_ToastInputs */



/**
* | output |
* | --- |
* | "Scene Detection Complete" |
*
* @param {Scene_Change_Detection_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_complete_toast = /** @type {((inputs?: Scene_Change_Detection_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Detection de scene terminee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Szenenerkennung abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rilevamento scena completato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обнаружение сцены завершено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detección de escena completa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("场景检测完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("シーン検出完了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दृश्य पहचान पूर्ण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Detecção de cena concluída")
	return /** @type {LocalizedString} */ ("Scene Detection Complete")
});